import { Pipe, PipeTransform } from '@angular/core';
import { GptLocalNumberPipe } from '@geneplanet/ngx-utils/src/lib/localization';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'refMinMax',
})
export class RefMinMaxPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(metric: { from: any; to: any }): string {
    const hasFrom = this.isNumber(metric.from);
    const hasTo = this.isNumber(metric.to);

    const toDecimal = (val: string) => {
      return new GptLocalNumberPipe(this.translate).transform(
        Number(val),
        '1.1-2'
      );
    };

    if (!hasFrom && !hasTo) {
      return '';
    } else if (hasFrom && hasTo) {
      return `${toDecimal(metric.from)}–${toDecimal(metric.to)}`;
    } else if (hasFrom) {
      return `≥ ${toDecimal(metric.from)}`;
    } else if (hasTo) {
      return `< ${toDecimal(metric.to)}`;
    }
  }

  private isNumber(value: any): boolean {
    return !isNaN(value) && value !== '' && value !== null;
  }
}
